import React, { useEffect, useState } from "react";
import { Box, Grid, Link, Typography } from "@mui/material";
import Logo from "../images/logo.png";
import { Container } from "@mui/system";
import Background from "../../src/images/footer-wave.png";
import Buildings from "../../src/images/building.png";
import { Link as RouterLink } from "react-router-dom";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import WPAPI from "wpapi";

const Footer = () => {
  const [menu, setMenu] = useState();

  //Fetch footer menu
  const wp = new WPAPI({ endpoint: WP_API_Settings.endpoint }); //custom API in functions.php
  wp.menus = wp.registerRoute("wp/v2", "menu-tree", {
    params: ["menu"],
  });
  useEffect(() => {
    wp.menus()
      .menu("footer-menu")
      .then((menuData) => {
        setMenu(menuData);
      });
  }, []);

  //console.log(menu)

  return (
    <>
      <Box
        sx={{
          position: "relative",
          height: "12vw",
          width: "100%",
        }}
      >
        <Box
          sx={{
            backgroundImage: `url(${Background})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            height: "12vw",
            width: "100%",
            position: "relative",
            zIndex: 2,
          }}
        />
        <Box
          sx={{
            backgroundImage: `url(${Buildings})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            height: "100%",
            width: "50%",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            zIndex: 1,
            position: "absolute",
            top: "4px",
            left: 0,
          }}
        />
      </Box>
      <Box
        sx={{
          p: "3rem 0",
          backgroundColor: "#1B314A",
          color: "#fff",
          "& a": {
            marginLeft: "0.25rem",
            color: "#fff",
            textDecoration: "none",
            "&:hover": {
              textDecoration: "underline",
              textDecorationColor: "rgba(255,255,255,0.5)",
            },
          },
        }}
      >
        <Container maxWidth="xl">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <img src={Logo} alt="S2 Logo" width="100px" />
            </Grid>
            <Grid item xs={12} md={3}>
              <Box
                sx={{
                  width: "fit-content",
                  m: "0 auto",
                }}
              >
                <Typography variant="h3" sx={{ mb: "0.4rem" }}>
                  Contact info
                </Typography>
                <Typography sx={{ m: "0.1rem 0" }}>
                  Email:
                  <a href="mailto:info@s2partnership.co.uk">
                    info@s2partnership.co.uk
                  </a>
                </Typography>
                <Typography sx={{ m: "0.1rem 0" }}>
                  Phone:
                  <a href="tel:+441954267788">01954 267788</a>
                </Typography>
                <Typography sx={{ m: "0.1rem 0" }}>
                  Head office: 12-16 Avenue Business Park, Elsworth, Cambridge
                  CB23 4EY
                </Typography>
                <Box sx={{ height: "0.4rem" }} />
                <a
                  style={{ marginLeft: 0 }}
                  href="https://www.linkedin.com/company/s2-partnership"
                  target="_blank"
                >
                  <LinkedInIcon />
                </a>
                {/* <a>
                                    <YouTubeIcon/>
                                </a> */}
              </Box>
            </Grid>
            {menu &&
              Object.values(menu).map((column) => {
                return (
                  <Grid item xs={12} md={3}>
                    <Box
                      sx={{
                        width: "fit-content",
                        m: {
                          xs: "0",
                          md: "0 auto",
                        },
                      }}
                    >
                      <Typography variant="h3" sx={{ mb: "0.4rem" }}>
                        {column.title}
                      </Typography>
                      {column.children &&
                        Object.values(column.children).map((child) => {
                          if (child?.title === "Riskwise Software") {
                          }
                          return (
                            <Link
                              component={RouterLink}
                              to={child.url}
                              sx={{
                                m: "0.1rem 0 !important",
                                display: "block",
                              }}
                            >
                              {child.title}
                            </Link>
                          );
                        })}
                    </Box>
                  </Grid>
                );
              })}
            <Grid item xs={12} />
            <Grid item xs={12}>
              <Typography variant="h3" sx={{ mb: "0.4rem" }}>
                Legal
              </Typography>
              <Typography>
                ©{new Date().getFullYear()} The S2 Partnership Ltd.
                <span style={{ margin: "0 1rem" }}>|</span>
                <Link component={RouterLink} to={"/privacy-policy-cookies/"}>
                  Privacy policy
                </Link>
                {/* <span style={{margin:'0 1rem'}}>
                                    |
                                </span>
                                <Link
                                    component={RouterLink}
                                >
                                    Terms of use
                                </Link> */}
              </Typography>
              <Typography sx={{ mt: "0.1rem" }}>
                S2 Partnership Ltd. Registered in England. Company No. 3706897.
                Registered Office: 23 Station Road, Sheringham, NR26 8RF
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Footer;
